import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'
import type { PageComponent } from '@/types'

import Head from 'next/head'
import { ThemeProvider } from 'next-themes'
import { JetBrains_Mono, Plus_Jakarta_Sans } from 'next/font/google'
import { Layout } from '@/components/generals/layout'
import { AcademicProvider } from '@/components/providers/academic-provider'
import { ConfirmProvider } from '@/components/providers/confirm-provider'
import { ToastProvider } from '@/components/providers/toast-provider'

const sans = Plus_Jakarta_Sans({
    subsets: ['latin']
})

const mono = JetBrains_Mono({
    subsets: ['latin']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    const bare = Boolean((Component as PageComponent).bare)
    const page = <Component {...pageProps} />

    return (
        <ThemeProvider attribute='class' defaultTheme='system' enableSystem disableTransitionOnChange>
            <AcademicProvider>
                <ToastProvider>
                    <ConfirmProvider>
                        <div className='h-full font-sans'>
                            <Head>
                                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                            </Head>

                            {bare ? page : <Layout>{page}</Layout>}
                        </div>
                    </ConfirmProvider>
                </ToastProvider>
            </AcademicProvider>
        </ThemeProvider>
    )
}

export default App
